/**
 *
 */

	document.addEventListener('DOMContentLoaded', function() {

		var isStorage = !!sessionStorage;
		if(isStorage) {

			var isStr = StorageOperator.isNotStorageData('session', 'state' );
			if( isStr ) {
	
				var state = StorageOperator.getStorageData('session', 'state');
	
				var poolObj = {};
	
				if(state.poolCateg) {
					var categ = state.poolCateg;
					if(categ==='Normal') {
						poolObj.array = state.or34===3 ? allDataObj.pool3: allDataObj.pool4;
					}else {
						poolObj.array = state.or34===3 ? allDataObj.highPool3: allDataObj.highPool4;
					};
				}else {
					poolObj.array = state.or34===3 ? allDataObj.pool3: allDataObj.pool4;
				};
	
				init(poolObj);
			}else {
	
				var isStrLo = StorageOperator.isNotStorageData('local', 'state');
				var or34 = isStrLo ? Number(StorageOperator.getStorageData('local', 'state')['or34']): 3;
				var boo = setOr34State(or34);
	
				var poolObj = {};
				poolObj.array = allDataObj.pool3;
	
				init(poolObj)
			};
	
		}else {
			alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};
	
	}, false);
	

	function setOr34State(val) {

		var stateObj = StorageOperator.makePageStateJson( val );

		var boo = [false, false];
		try {
			boo = StorageOperator.setStorageData( 'session', 'state', stateObj );		
		}catch(exeption) {
			//alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};
		return boo[0];
	};


	var secondView;

	function init( poolObj ) {
		
		secondView = new SecondView( poolObj );

		document.getElementById('ifra-result').src = './NumbResult.html';

		addWindowScrollEvent();

		funcWindowSize();
		
		if ("ontouchstart" in window) {
			MyUtility.setElementEvent('navData-down', 'click', MyUtility.buttonDownProcess( 'nav-pull-ul', false), false);
			MyUtility.setElementEvent('navData-down-2', 'click', MyUtility.buttonDownProcess( 'nav-pull-ul-2', false), false);
		}else {

			MyUtility.focusDownProcess( 'navData-down-li', 'nav-pull-ul' );
			MyUtility.focusDownProcess( 'navData-down-li-2', 'nav-pull-ul-2' );
		};


		//  コンテンツボタン
		let objList = [ { idString: 'cont-pull-ul-1', is: false }, { idString: 'cont-pull-ul-2', is: false },
						{ idString: 'cont-pull-ul-3', is: false }, { idString: 'cont-pull-ul-4', is: false } ];

		MyUtility.setElementEvent('cont-label-down-1', 'click', MyUtility.buttonDownBoxProcess( objList, 0), false);
		MyUtility.setElementEvent('cont-label-down-2', 'click', MyUtility.buttonDownBoxProcess( objList, 1), false);
		MyUtility.setElementEvent('cont-label-down-3', 'click', MyUtility.buttonDownBoxProcess( objList, 2), false);
		MyUtility.setElementEvent('cont-label-down-4', 'click', MyUtility.buttonDownBoxProcess( objList, 3), false);
        // コンテンツボタン  モバイル用
        for(var i=0; i<4; i++) {
            if(document.getElementById('cont-pull-ul-'+(i+1)+'-mov')) {
                MyUtility.setElementStyle('cont-pull-ul-'+(i+1)+'-mov', 'display', 'none');
            };
        };
        let objList_mov = [ { idString: 'cont-pull-ul-1-mov', is: false }, { idString: 'cont-pull-ul-2-mov', is: false },
                        { idString: 'cont-pull-ul-3-mov', is: false }, { idString: 'cont-pull-ul-4-mov', is: false } ];
        for(var i=0; i<4; i++) {
            if(document.getElementById('cont-label-down-'+(i+1)+'-mov')) {
                MyUtility.setElementEvent('cont-label-down-'+(i+1)+'-mov', 'click', MyUtility.buttonDownBoxProcess( objList_mov, i), false);
            };
        };


		var or34 =  Number(StorageOperator.getStorageData('session', 'state')['or34']);
		if(or34===3) {
			document.getElementById('nb3Img').style['display'] = 'block';
		}else {
			document.getElementById('nb4Img').style['display'] = 'block';
		};

		//  topSub
		document.getElementById('topSub-div').addEventListener('mouseenter', function() { return topSubFocus(topSubFocusSub)}, false);

	};

	
	function topSubFocus(sub) {
		let timer = window.setTimeout(function() {
			document.getElementById("topSub-inn-div").style['display'] = 'none';
			document.getElementById("soukannzu-div").style['display'] = 'block';
		},300);
		document.getElementById('topSub-div').removeEventListener('mouseleave',() => sub(), false);
		document.getElementById('topSub-div').addEventListener('mouseleave',() => sub(timer), false);
	};
	function topSubFocusSub(timer) {
		if(timer) {   window.clearTimeout(timer);   };
		document.getElementById("topSub-inn-div").style['display'] = 'block';
		document.getElementById("soukannzu-div").style['display'] = 'none';
	};


	/*  skip scroll  */
	function addWindowScrollEvent() {

		window.onscroll = function(){
			//  スクロール値取得
			let offsetY = window.pageYOffset;

			if(offsetY>650) {
				document.getElementById('skipDiv').style['display'] = 'block';
			}else {
				document.getElementById('skipDiv').style['display'] = 'none';
			};
		};
		window.addEventListener("resize", funcWindowSize, false);

		MyUtility.setElementEvent( 'skipTop', 'click', skipeTop, false );
		MyUtility.setElementEvent( 'skipBottom', 'click', skipeBottom, false );
	};



	// skip DOM 操作

	function funcWindowSize() {

		var width = window.innerWidth;

		if(width > 1200) {
			document.getElementById("skipDiv").style.right = (width-1100)/2-55+'px';
		}else if(width>500){
			document.getElementById("skipDiv").style.right = "20px";
		}else {
			document.getElementById("skipDiv").style.right = "10px";
			document.getElementById("skipDiv").style.bottom = "8px";
		};
	};


	function skipeTop() {

		const offsetY = window.pageYOffset;

		const range = offsetY > 2000 ? offsetY/20 :  100;

		var timer = window.setInterval( () => windowScroll( timer, true, range, 0), 12 );

		//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
		var timer2 = window.setTimeout( () => window.clearInterval( timer ), 500);

	};

	function skipeBottom() {

		const offsetY = window.pageYOffset;
		const windowH = window.innerHeight;

		const footerTop = offsetY+document.getElementById('footerTop').getBoundingClientRect().top;

		const range = footerTop-offsetY > 2000 ? (footerTop-offsetY)/20 : 100;

		var timer = window.setInterval( () => windowScroll( timer, false, range, footerTop-windowH ), 12 );

		//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
		var timer2 = window.setTimeout( () => window.clearInterval( timer ), 500);

	};


	function windowScroll( timer, isUpDown, range, end) {

		let offsetY = window.pageYOffset;

		if(isUpDown) {
			if(end>=offsetY) {
				window.clearInterval( timer );
			}else {
				offsetY = offsetY-range < end ? end : offsetY-range;
				window.scroll(0, offsetY);
			};
		}else {
			if(end-20<=offsetY) {
				window.clearInterval(timer);
			}else {
				offsetY = offsetY+range > end ? end : offsetY+range;
				window.scroll(0, offsetY);
			};
		};
	};


	function setState34(val) {

		var isStorage = !!sessionStorage;

		if(isStorage) {
			var stateObj = StorageOperator.makePageStateJson( val );

			var boo = [false, false], boo2 = [false, false];
			try {
				boo = StorageOperator.setStorageData( 'session', 'state', stateObj );
				boo2 = StorageOperator.setStorageData( 'local', 'state', stateObj );
				
			}catch(exeption) {
				alert('お使いのブラウザでは、本サイトは正常に動作しません');
			};
			//var isStr = StorageOperator.isNotStorageData('session', 'nb_result', 'nb_pool3', 'nb_pool4');

			//if( ! isStr ) {   alert('データ取得中です');   boo[0] = false;   };

			return boo[0] && boo2[0];
		};
		return false;
	};









